import React, { useState } from "react";
import {
  Image,
  StyleSheet,
  TouchableOpacity,
  View,
  Linking,
} from "react-native";
import Text from "@components/CustomText";
import OrderStatus from "@assets/svg/OrderStatus";
import colors from "@constants/color";
import { normalize } from "@constants/metrics";
import { actions as returnOrderActions } from "@reducers/returnOrdersReducer";
import { useDispatch } from "react-redux";
import analytics from "@services/analytics";
import { RVP_EVENTS } from "@constants/analyticsEvents";
import PickupScheduleModal from "../pickupScheduleModal";
import CustomModal from "../CustomModal";

const ReturnOrderCard = (props) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showPickupSchedModal, setShowPickupSchedModal] = useState(false);
  const [selpickupDate, setSelPickupDate] = useState("");

  const dispatch = useDispatch();

  const { item = {}, navigateToDetails = () => {} } = props;
  const {
    order_id = "",
    order_created_at,
    qty,
    product_image,
    short_name,
    agg_status_text,
    price_after_discount,
    payment_status,
    agg_status_icon,
    pickup_date_text,
    agg_status_color,
    enable_schedule,
    enable_cancel,
    set_schedule_date_text,
    cancel_btn_text,
    user_name,
    user_phone,
    cx_formatted_address,
    cancel_confirmation_text,
    cancel_confirmation_heading,
    cancel_confirm_options,
    return_req_id,
    possible_pickup_days,
    resolved_status = {},
    sku_id,
    returnable,
    days_left,
    return_reason,
    request_type,
    return_qty,
    reject_reason,
    status,
  } = item;

  return (
    <>
      <CustomModal
        visible={showCancelModal}
        heading={cancel_confirmation_heading}
        message={cancel_confirmation_text}
        buttons={cancel_confirm_options}
        setShowModal={() => setShowCancelModal(false)}
        return_req_id={return_req_id}
        onPress={() => {
          dispatch(
            returnOrderActions.cancelReturnRequest({
              return_req_id,
            }),
          );
        }}
      />
      <PickupScheduleModal
        visible={showPickupSchedModal}
        onPress={() =>
          dispatch(
            returnOrderActions.pickupRVPScheduleReq({
              return_req_id,
              scheduled_date: selpickupDate,
            }),
          )
        }
        selpickupDate={selpickupDate}
        setSelPickupDate={(date) => setSelPickupDate(date)}
        pickupDays={
          possible_pickup_days
            ? possible_pickup_days.map((pickupDay) => ({
                text: pickupDay.date_text,
                key: pickupDay.date,
              }))
            : []
        }
        setShowModal={() => setShowPickupSchedModal(false)}
        return_req_id={return_req_id}
      />
      <TouchableOpacity
        testID="oroc-card"
        style={styles.cardView}
        onPress={() => navigateToDetails(order_id, "RETURN")}
      >
        <View style={styles.topContainer}>
          <View style={styles.orderIdContainer}>
            <Text style={styles.orderNumberText}>
              आर्डर नंबर -
              <Text style={styles.orderNumValText}>{` ${order_id}`}</Text>
            </Text>
          </View>
          <View style={styles.orderDateContainer}>
            <Text style={styles.orderNumberText}>आर्डर की तारीख -</Text>
            <Text
              style={styles.orderNumValText}
            >{` ${order_created_at.trim()}`}</Text>
          </View>
        </View>
        <View style={{ margin: 0 }}>
          <Text style={styles.itemText}>{`1 आइटम्स • ${qty} मात्रा`}</Text>
        </View>
        <View style={styles.imageView}>
          {product_image && (
            <Image
              resizeMode="contain"
              source={{ uri: product_image }}
              style={styles.image}
            />
          )}
          <View style={{ width: normalize(200) }}>
            <Text style={styles.productName}>{short_name}</Text>
          </View>
        </View>
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          <View>
            <Text style={styles.nameText}>{user_name}</Text>
            <TouchableOpacity
              testID="oroc-whatsapp"
              onPress={() =>
                Linking.openURL(`whatsapp://send?phone=+91${user_phone}`)
              }
            >
              <View>
                <Text
                  style={{
                    color: colors.lightBlack,
                    fontSize: 12,
                    lineHeight: 16,
                    fontFamily: "NotoSansDevanagari-Regular",
                  }}
                >
                  +91 - {user_phone}
                </Text>
              </View>
            </TouchableOpacity>
          </View>
          <View>
            <Text style={styles.namePriceText}>
              {price_after_discount > 0
                ? `₹${parseInt(price_after_discount, 10)}`
                : ""}
            </Text>
            <Text style={styles.paymentStatus}>
              {price_after_discount > 0 ? ` ${payment_status}` : ""}
            </Text>
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            paddingTop: normalize(12),
            paddingBottom: normalize(4),
          }}
        >
          <OrderStatus
            orderStatus={agg_status_icon}
            style={{ marginRight: 6 }}
            orderStatusColor={agg_status_color}
          />
          <Text
            style={[
              styles.statusText,
              {
                color: agg_status_color,
              },
            ]}
          >
            {agg_status_text}{" "}
            {pickup_date_text && status !== "REJECTED"
              ? `| ${pickup_date_text}`
              : ""}
          </Text>
          {Boolean(reject_reason) && (
            <Text style={{ color: agg_status_color, marginBottom: 5 }}>
              - {reject_reason}
            </Text>
          )}
        </View>
        {cx_formatted_address && (
          <View style={{ width: "90%", flexDirection: "row" }}>
            <Text
              style={{
                lineHeight: 16,
                fontSize: 12,
                color: "rgba(0, 0, 0, 0.56)",
                fontFamily: "NotoSansDevanagari-Regular",
              }}
            >
              {cx_formatted_address}
            </Text>
          </View>
        )}
        {resolved_status?.key ? (
          <Text
            style={[
              styles.resolvedStatus,
              { color: resolved_status?.color || colors.lightBlack },
            ]}
          >
            {resolved_status?.key} :
            <Text
              onPress={() => {
                if (resolved_status?.is_external_link) {
                  Linking.openURL(resolved_status?.value);
                }
              }}
            >
              {resolved_status?.value}
            </Text>
          </Text>
        ) : null}
        <View
          style={[
            styles.buttonView,
            {
              paddingTop: enable_cancel || enable_schedule ? normalize(20) : 0,
            },
          ]}
        >
          {enable_cancel && (
            <TouchableOpacity
              testID="oroc-cancel"
              onPress={() => {
                setShowCancelModal(true);
                analytics.trackEvent(RVP_EVENTS.RETURN_CANCELLED, {
                  order_id,
                  return_req_id,
                  sku_id,
                  returnable,
                  days_left,
                  return_reason,
                  request_type,
                  return_qty,
                });
              }}
              style={[
                styles.cancelButton,
                {
                  width: enable_schedule ? normalize(158) : normalize(328),
                  marginRight: enable_schedule ? normalize(6) : 0,
                },
              ]}
            >
              <Text style={styles.cancelText}>{cancel_btn_text}</Text>
            </TouchableOpacity>
          )}
          {enable_schedule && (
            <TouchableOpacity
              testID="oroc-pickup-schedule"
              style={[
                styles.pickupButton,
                {
                  width: enable_cancel ? normalize(158) : normalize(328),
                  marginRight: enable_cancel ? normalize(6) : 0,
                },
              ]}
              onPress={() => setShowPickupSchedModal(true)}
            >
              <Text style={styles.pickupText}>{set_schedule_date_text}</Text>
            </TouchableOpacity>
          )}
        </View>
      </TouchableOpacity>
    </>
  );
};

const styles = StyleSheet.create({
  cardView: {
    flexDirection: "column",
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginVertical: 5,
    backgroundColor: colors.white,
  },
  orderDateContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  orderIdContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  topContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  image: {
    marginRight: 15,
    height: 50,
    width: 50,
    borderWidth: 1,
    borderColor: colors.lighterBlack,
  },
  namePriceText: {
    fontSize: normalize(16),
    fontFamily: "NotoSansDevanagari-Bold",
    color: colors.mediumBlack,
  },
  orderNumberText: {
    fontSize: normalize(14),
    color: colors.lightBlack,
    fontFamily: "NotoSansDevanagari-Regular",
  },
  orderNumValText: {
    fontWeight: "bold",
    color: colors.black,
    fontSize: normalize(14),
  },
  itemText: {
    fontSize: normalize(12),
    color: colors.lightBlack,
    fontFamily: "NotoSansDevanagari-Regular",
  },
  imageView: {
    flexDirection: "row",
    paddingTop: normalize(12),
    paddingBottom: normalize(17),
  },
  productName: {
    color: colors.mediumBlack,
    fontSize: normalize(14),
    fontFamily: "NotoSansDevanagari-Regular",
  },
  statusText: {
    fontWeight: "bold",
    fontSize: 16,
    fontFamily: "Mukta",
  },
  paymentStatus: {
    color: colors.lightBlack,
    fontSize: 12,
    lineHeight: 16,
    fontFamily: "NotoSansDevanagari-Regular",
  },
  cancelButton: {
    borderWidth: 1,
    borderColor: colors.borderBox,
    paddingTop: normalize(10),
    borderRadius: normalize(6),
    marginRight: normalize(6),
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: normalize(4),
  },
  pickupButton: {
    backgroundColor: colors.primary,
    paddingTop: normalize(10),
    borderRadius: normalize(6),
    width: normalize(158),
    marginLeft: normalize(6),
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: normalize(4),
  },
  cancelText: {
    fontSize: normalize(14),
    fontFamily: "NotoSansDevanagari-SemiBold",
  },
  pickupText: {
    fontSize: normalize(14),
    fontFamily: "NotoSansDevanagari-SemiBold",
    color: colors.white,
  },
  buttonView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignSelf: "center",
    paddingTop: normalize(20),
  },
  nameText: {
    fontSize: normalize(16),
    fontFamily: "NotoSansDevanagari-Bold",
    color: colors.mediumBlack,
  },
  resolvedStatus: {
    fontSize: normalize(12),
    fontFamily: "Mulish-Regular",
    color: colors.lightBlack,
  },
});

export default ReturnOrderCard;
